import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import SelectPill from '../../../../../../components/SelectPill';
import { useNotification } from '../../../../../../hooks';
import { useOmnichannelFilter } from '../../hooks/useOmnichannelFilter';
import { OMNICHANNEL_MAX_REDES, OMNICHANNEL_MAX_REDES_MESSAGE } from '../../constants';
import { LocaleType } from '../../types';
import styles from './ChainSelect.module.scss';

export type ChainSelectProps = {
  locale: LocaleType;
  renderMenu: (menu: React.ReactNode) => React.ReactNode;
  placeholder: (name: string, list: string[]) => string;
};

export const ChainSelect = ({ locale, renderMenu, placeholder }: ChainSelectProps) => {
  const { rede, filterHandlers } = useOmnichannelFilter();
  const { handleNotification } = useNotification();
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={styles['chain-select-wrapper']}>
      <Controller
        name="redes"
        control={control}
        render={({ field }) => (
          <SelectPill
            id={errors?.redes ? 'select-pill-is-empty' : 'check-picker-pill'}
            type="check"
            placeholder={placeholder('rede', field.value || [])}
            name="redes"
            value={field.value || []}
            data={rede?.list}
            locale={locale}
            renderMenu={renderMenu}
            onSelect={(value: string[]) => {
              const capped = value.slice(0, OMNICHANNEL_MAX_REDES);
              if (value.length > OMNICHANNEL_MAX_REDES) {
                handleNotification('warn', OMNICHANNEL_MAX_REDES_MESSAGE);
              }
              field.onChange(capped);
              filterHandlers.handleSelectFilter('rede', capped);
            }}
            onOpen={() => filterHandlers.onSearchFilter('rede', '')}
            onSearch={(value: string) => filterHandlers.onSearchFilter('rede', value)}
            onClean={() => {
              field.onChange([]);
              filterHandlers.handleClearFilters('rede');
            }}
          />
        )}
      />
    </div>
  );
};
